import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { usePrefs } from '@/app/prefs';
import { ApiError } from '@/lib/api';
import { Button, Card, EmptyState } from '@/components/ui';

/**
 * Catches anything a route throws — a failed lazy import, a render crash, an
 * unhandled API error — so a single broken screen never leaves clinic staff
 * staring at a blank page mid-consultation.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const { t } = usePrefs();

  const title = (() => {
    if (isRouteErrorResponse(error)) return error.status === 404 ? t.common.notFound : t.common.error;
    if (error instanceof ApiError) {
      if (error.code === 'FORBIDDEN') return t.errors.FORBIDDEN;
      if (error.code === 'NOT_FOUND') return t.errors.NOT_FOUND;
    }
    return t.common.error;
  })();

  // The developer-facing detail is logged, never rendered — it is English and
  // could name internals.
  console.error('[route] unhandled error', error);

  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh', padding: 24 }}>
      <Card style={{ maxWidth: 460, width: '100%' }} flush>
        <EmptyState
          icon="alert"
          title={title}
          sub={t.common.noDataSub}
          action={
            <div style={{ display: 'flex', gap: 8 }}>
              <Button onClick={() => window.location.reload()}>{t.btn.retry}</Button>
              <Link to="/" className="btn btn-primary">
                {t.common.backHome}
              </Link>
            </div>
          }
        />
      </Card>
    </div>
  );
}
